import { useTranslation } from 'react-i18next';
import AnswerContainer from './answer-container';
import NovartisLiveChatButton from './novartis-live-chat-button';
import { CURRENT_INSTANCE } from '../../tenant';
import MarkdownRenderer from '../common/markdown-renderer';

interface InvalidQueryMessageProps {
  userQuery?: string;
}

function InvalidQueryMessage(props: InvalidQueryMessageProps) {
  const { t } = useTranslation();

  return (
    <AnswerContainer>
      <div>
        {t('chat.response.invalid_query_intro')}
        <br />
        <br />
        <MarkdownRenderer content={CURRENT_INSTANCE.content.medicalInfo} />
        <NovartisLiveChatButton query={props.userQuery} />
      </div>
    </AnswerContainer>
  );
}

export default InvalidQueryMessage;
